<!-- Breadcrumb padronizado -->
<app-breadcrumb containerStyle="normal"></app-breadcrumb>

<div class="card" style="border-radius: 10px">
  <div class="card-body">
    <div class="row text-left">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between mb-0">
          <h1 class="text-bold-400" style="color: #4e7977">
            Acesso Remoto
          </h1>
        </div>
      </div>
      <div class="col-sm-12">
        <p class="mb-2 mt-2" style="font-size: 20px">
          Consulte e gerencie os servidores com acesso direto ao seu cadastro no sistema. Utilize a busca e os filtros para encontrar e atualizar informações de forma eficiente. É possível cadastrar novos usuários através do modelo de importação.
        </p>
      </div>
    </div>

    <hr class="mb-4">

    <form #filtroForm="ngForm" novalidate>
      <div class="form-row">
        <div class="col-6">
          <div class="form-group">
            <div class="controls">
              <label for="cliente" style="font-size: 14px">Cliente</label>
              <fieldset class="form-group position-relative has-icon-right">
                <input
                  type="text"
                  id="cliente"
                  class="form-control"
                  placeholder="Digite o nome do cliente"
                  name="cliente"
                  [(ngModel)]="filters.cidade"
                  aria-invalid="false"
                />
                <div class="form-control-position">
                  <i class="ft-search"></i>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <div class="controls">
              <label for="nome" style="font-size: 14px">Nome</label>
              <fieldset class="form-group position-relative has-icon-right">
                <input
                  type="text"
                  id="nome"
                  class="form-control"
                  placeholder="Digite o nome do usuário"
                  name="nome"
                  [(ngModel)]="filters.nome"
                  aria-invalid="false"
                />
                <div class="form-control-position">
                  <i class="ft-search"></i>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <div class="controls">
              <label for="login" style="font-size: 14px">Usuário/Login</label>
              <fieldset class="form-group position-relative has-icon-right">
                <input
                  type="text"
                  id="login"
                  class="form-control"
                  placeholder="Digite o login do usuário"
                  name="login"
                  [(ngModel)]="filters.login"
                  aria-invalid="false"
                />
                <div class="form-control-position">
                  <i class="ft-user"></i>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col-6">
          <div class="form-group">
            <label style="font-size: 14px">Período de Cadastro</label>
            <div class="d-flex align-items-center">
              <div class="input-group" style="flex: 1;">
                <input
                  type="text"
                  id="dataInclusaoDe"
                  class="form-control"
                  mask="00/00/0000"
                  [(ngModel)]="filters.dataInclusaoDe"
                  name="dataInclusaoDe"
                  placeholder="dd/mm/yyyy"
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
              <span class="mx-3">até</span>
              <div class="input-group" style="flex: 1;">
                <input
                  type="text"
                  id="dataInclusaoAte"
                  class="form-control"
                  mask="00/00/0000"
                  [(ngModel)]="filters.dataInclusaoAte"
                  name="dataInclusaoAte"
                  placeholder="dd/mm/yyyy"
                  aria-invalid="false"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row d-flex justify-content-end align-items-center">
        <div class="col-auto">
          <button type="button" class="btn btn-outline-primary" (click)="clearFilters()">
            Limpar filtros
          </button>
        </div>
        <div class="col-auto">
          <button type="button" class="btn btn-outline-primary mb-2 mb-md-0" (click)="applyFilters()">
            Pesquisar <i class="fa fa-search mr-1"></i>
          </button>
        </div>
      </div>
    </form>

    <hr class="my-4">

    <div class="form-row d-flex justify-content-end align-items-center">
      <div class="col-auto">
        <button type="button" class="btn btn-primary" (click)="download('model.xlsx', 'model.xlsx')">
          <i class="fa fa-download mr-2"></i>Baixar Modelo
        </button>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-primary" (click)="openUploadModal(uploadModal)">
          <i class="fa fa-upload mr-2"></i>Upload Usuários
        </button>
      </div>
    </div>
  </div>
</div>

<div class="card" style="border-radius: 10px">
  <table class="table text-center" style="padding: 10px" *ngIf="usuarios.length > 0">
    <thead>
      <tr>
        <th (click)="sortTable('municipio')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Município
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('municipio')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('municipio')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('municipio')"
                class="fa"
                [ngClass]="getSortIcon('municipio')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('nome')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Nome
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('nome')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('nome')"
                class="fa"
                [ngClass]="getSortIcon('nome')"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('login')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Senha
            <div class="sort-icons ml-1">
              <i *ngIf="!isColumnSorted('login')" class="fa fa-caret-up"></i>
              <i *ngIf="!isColumnSorted('login')" class="fa fa-caret-down"></i>
              <i
                *ngIf="isColumnSorted('login')"
                class="fa"
                [ngClass]="getSortIcon('login')"
              ></i>
            </div>
          </div>
        </th>
        <th>
          <div class="d-flex align-items-center justify-content-center">
            Ações
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let usuario of usuarios">
        <td class="pl-3 pr-3 align-middle">
          <div class="d-flex align-items-center justify-content-center texto-linha-tabela">
            {{ usuario.cidade_nome || filters.cidade || 'N/A' }}
          </div>
        </td>
        <td class="text-center align-middle texto-linha-tabela">
          <ng-template [ngIf]="usuario.servidor">
            <a [routerLink]="['/servidor']" [queryParams]="{id: usuario.servidor}">
              {{ usuario.user }}
            </a>
          </ng-template>
          <ng-template [ngIf]="!usuario.servidor">
            {{ usuario.user }}
          </ng-template>
        </td>
        <td class="text-center align-middle texto-linha-tabela">
          {{ usuario.password }}
        </td>
        <td class="d-flex justify-content-center">
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-outline-danger" title="Excluir usuário" (click)="excluirUsuario(usuario)">
              <i class="fa fa-trash"></i>
            </button>
            <button type="button" class="btn btn-outline-primary" title="Alterar senha" (click)="openModal(atualizarSenha, usuario)">
              Alterar Senha
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <!-- Paginação -->
  <div class="form-row mt-2 d-flex justify-content-end" style="margin: 5px" *ngIf="total > 0">
    <ngb-pagination
      class="ml-auto"
      style="margin-top: 10px; margin-right: 10px"
      [(page)]="page"
      [pageSize]="pageSize"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="true"
      size="sm"
      [collectionSize]="total"
      (pageChange)="onPageChange($event)"
    ></ngb-pagination>
  </div>

  <!-- Mensagem quando não há usuários -->
  <div class="card-body" *ngIf="usuarios.length == 0">
    <div class="text-center">
      <h5 class="mt-0">Nenhum usuário encontrado.</h5>
      <p class="text-muted">Não foram encontrados usuários para os filtros aplicados.</p>
    </div>
  </div>
</div>

<!-- Modal para upload de usuários -->
<ng-template #uploadModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h4 class="modal-title">Upload de Novos Usuários</h4>
    <button type="button" class="btn-close" aria-label="Close" style="font-size: 24px" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <!-- Linha divisória após título principal -->
  <hr class="modal-divider">
  
  <div class="modal-body">
    <h6 class="section-title">Informações do Arquivo</h6>
    <p class="text-muted mb-4">Selecione um arquivo Excel para importação de novos usuários.</p>
    
    <form #uploadForm="ngForm" novalidate>
      <div class="form-group mb-4">
        <label for="arquivo" class="form-label">ARQUIVO EXCEL</label>
        <input 
          type="file" 
          id="arquivo" 
          name="arquivo" 
          class="form-control" 
          (change)="selecionaArquivo($event)" 
          accept=".xls,.xlsx" 
          required>
        <small class="form-text text-muted">Apenas arquivos no formato .xls ou .xlsx são aceitos.</small>
      </div>
    </form>
  </div>
  
  <div class="modal-footer border-0 pt-0">
    <!-- HR no rodapé ao invés de linha inteira -->
    <hr class="footer-divider">
    <div class="d-flex">
      <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss('Cancel')">
        Voltar
      </button>
      <button 
        type="button" 
        class="btn btn-primary" 
        (click)="processarUpload(modal)"
        [disabled]="!arquivoSelecionado">
        Enviar
      </button>
    </div>
  </div>
</ng-template>

<!-- Modal para atualizar senha -->
<ng-template #atualizarSenha let-modal>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Nova Senha</h4>
    </div>
    <div class="card-content">
      <div class="card-body">
        <form #exForm="ngForm" class="editForm" novalidate>
          <div class="form-row">
            <div class="col-12">
              <div class="form-group mb-2">
                <label for="novaSenha">Nova Senha</label>
                <input type="text" id="novaSenha" class="form-control" name="novaSenha" [(ngModel)]="atualizacaoSenha.novaSenha" #inputSenha="ngModel" required>
              </div>
              <div class="form-group mb-2">
                <label for="confirmaNovaSenha">Confirme a Nova Senha</label>
                <input type="text" id="confirmaNovaSenha" class="form-control" name="confirmaNovaSenha" [(ngModel)]="atualizacaoSenha.confirmaNovaSenha" #inputConfir="ngModel" required>
              </div>
              <div class="form-row mt-4">
                <div class="col-6 text-center">
                  <button type="button" class="btn btn-lg btn-block btn-secondary" (click)="modal.close('Close click')">Cancelar</button>
                </div>
                <div class="col-6 text-center">
                  <button type="button" class="btn btn-lg btn-primary btn-block" (click)="updateSenha(modal)" [disabled]="!atualizacaoSenha || !atualizacaoSenha.novaSenha || !atualizacaoSenha.confirmaNovaSenha || (atualizacaoSenha.novaSenha!=atualizacaoSenha.confirmaNovaSenha)">Atualizar</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <ngx-spinner></ngx-spinner>
</ng-template>

<ngx-spinner></ngx-spinner>
